import React from 'react';
import { Box } from '@wix/design-system';
import { TldPromotionContent } from '../TldPromotion/TldPromotionContent';
import { TldPromotionsListSkeleton } from './TldPromotionsListSkeleton';
import styles from './TldPromotionsList.scss';
export const TldPromotionsList = _ref => {
  let {
    promotions,
    isLoading,
    dataHook,
    compact = false,
    Label,
    PromotionBadge,
    PromotionPrice
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHook,
    width: "100%",
    direction: "vertical"
  }, isLoading ? /*#__PURE__*/React.createElement(TldPromotionsListSkeleton, {
    limit: (promotions == null ? void 0 : promotions.length) || 8
  }) : promotions.map(promotion => /*#__PURE__*/React.createElement(Box, {
    key: promotion.id,
    padding: compact ? '12px 24px' : '20px 24px',
    direction: "vertical",
    gap: "SP4",
    align: "space-between",
    position: "relative",
    className: styles.item
  }, /*#__PURE__*/React.createElement(TldPromotionContent, {
    tld: promotion.tld,
    pricing: promotion.pricing,
    description: promotion.description,
    Label: Label,
    PromotionBadge: PromotionBadge,
    PromotionPrice: PromotionPrice
  }))));
};
//# sourceMappingURL=TldPromotionsList.js.map